export default __webpack_public_path__ + "static/media/k.1399e7c6.png";